export const ItemTypes = {
    BOX: 'box',
}

export const PADDING_LAYOUT = 40
export const PADDING_FRAME_CONTROL = 14